import { render, staticRenderFns } from "./Phototask.vue?vue&type=template&id=4834a78c&scoped=true"
import script from "./Phototask.vue?vue&type=script&lang=js"
export * from "./Phototask.vue?vue&type=script&lang=js"
import style0 from "./Phototask.vue?vue&type=style&index=0&id=4834a78c&prod&lang=scss&scoped=true"
import style1 from "./Phototask.vue?vue&type=style&index=1&id=4834a78c&prod&scoped=true&lang=css"
import style2 from "./Phototask.vue?vue&type=style&index=2&id=4834a78c&prod&lang=css"
import style3 from "./Phototask.vue?vue&type=style&index=3&id=4834a78c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4834a78c",
  null
  
)

/* custom blocks */
import block0 from "./Phototask.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports